import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import _uniqWith from 'lodash/uniqWith'
import _isEqual from 'lodash/isEqual'
import {
  valveTimeToEpoch,
  valveTimeToEpochMillis,
  toValveTime,
} from 'altrac-conversions'

import {
  SelectInput,
  TimeInput,
} from '../Inputs/Inputs'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

// HOC
import withAppStore from '../../../util/withAppStore'

import styles from '../../../../css/settings.module.css'

const VALVE_OPEN = 1
const VALVE_CLOSE = 0
const options = {
  hours: [
    { value: 0, name: '0 HRS' },
    { value: 1, name: '1 HRS' },
    { value: 2, name: '2 HRS' },
    { value: 3, name: '3 HRS' },
    { value: 4, name: '4 HRS' },
    { value: 5, name: '5 HRS' },
    { value: 6, name: '6 HRS' },
    { value: 7, name: '7 HRS' },
    { value: 8, name: '8 HRS' },
    { value: 9, name: '9 HRS' },
    { value: 10, name: '10 HRS' },
    { value: 11, name: '11 HRS' },
    { value: 12, name: '12 HRS' },
    { value: 13, name: '13 HRS' },
    { value: 14, name: '14 HRS' },
    { value: 15, name: '15 HRS' },
    { value: 16, name: '16 HRS' },
    { value: 17, name: '17 HRS' },
    { value: 18, name: '18 HRS' },
    { value: 19, name: '19 HRS' },
    { value: 20, name: '20 HRS' },
    { value: 21, name: '21 HRS' },
    { value: 22, name: '22 HRS' },
    { value: 23, name: '23 HRS' },
  ],
  minutes: [
    { value: 0, name: '0 MIN' },
    { value: 1, name: '1 MIN' },
    { value: 2, name: '2 MIN' },
    { value: 3, name: '3 MIN' },
    { value: 4, name: '4 MIN' },
    { value: 5, name: '5 MIN' },
    { value: 6, name: '6 MIN' },
    { value: 7, name: '7 MIN' },
    { value: 8, name: '8 MIN' },
    { value: 9, name: '9 MIN' },
    { value: 10, name: '10 MIN' },
    { value: 11, name: '11 MIN' },
    { value: 12, name: '12 MIN' },
    { value: 13, name: '13 MIN' },
    { value: 14, name: '14 MIN' },
    { value: 15, name: '15 MIN' },
    { value: 16, name: '16 MIN' },
    { value: 17, name: '17 MIN' },
    { value: 18, name: '18 MIN' },
    { value: 19, name: '19 MIN' },
    { value: 20, name: '20 MIN' },
    { value: 21, name: '21 MIN' },
    { value: 22, name: '22 MIN' },
    { value: 23, name: '23 MIN' },
    { value: 24, name: '24 MIN' },
    { value: 25, name: '25 MIN' },
    { value: 26, name: '26 MIN' },
    { value: 27, name: '27 MIN' },
    { value: 28, name: '28 MIN' },
    { value: 29, name: '29 MIN' },
    { value: 30, name: '30 MIN' },
    { value: 31, name: '31 MIN' },
    { value: 32, name: '32 MIN' },
    { value: 33, name: '33 MIN' },
    { value: 34, name: '34 MIN' },
    { value: 35, name: '35 MIN' },
    { value: 36, name: '36 MIN' },
    { value: 37, name: '37 MIN' },
    { value: 38, name: '38 MIN' },
    { value: 39, name: '39 MIN' },
    { value: 40, name: '40 MIN' },
    { value: 41, name: '41 MIN' },
    { value: 42, name: '42 MIN' },
    { value: 43, name: '43 MIN' },
    { value: 44, name: '44 MIN' },
    { value: 45, name: '45 MIN' },
    { value: 46, name: '46 MIN' },
    { value: 47, name: '47 MIN' },
    { value: 48, name: '48 MIN' },
    { value: 49, name: '49 MIN' },
    { value: 50, name: '50 MIN' },
    { value: 51, name: '51 MIN' },
    { value: 52, name: '52 MIN' },
    { value: 53, name: '53 MIN' },
    { value: 54, name: '54 MIN' },
    { value: 55, name: '55 MIN' },
    { value: 56, name: '56 MIN' },
    { value: 57, name: '57 MIN' },
    { value: 58, name: '58 MIN' },
    { value: 59, name: '59 MIN' },
  ],
}

const TimeSet = ({ devices, params }) => {
  const [selectedDay, setSelectedDay] = useState(moment())
  const [selectedTime, setSelectedTime] = useState(moment())
  const [selectedRunTimeHours, setSelectedRunTimeHours] = useState(1)
  const [selectedRunTimeMinutes, setSelectedRunTimeMinutes] = useState(0)
  const [startTime, setStartTime] = useState(moment())
  const [stopTime, setStopTime] = useState(moment().add(1, 'hours'))
  const [settingArrNo, setSettingArrNo] = useState(0)
  const [deviceValveSettings, setDeviceValveSettings] = useState([])
  const [deviceValveSettingsById, setDeviceValveSettingsById] = useState({})
  const [settingNew, setSettingNew] = useState(true)

  // Initialize device valve settings
  useEffect(() => {
    let selectedDay = moment()
    let selectedTime = moment()
    let selectedRunTimeHours = 1
    let selectedRunTimeMinutes = 0
    let startTime = moment()
    let stopTime = moment().add(1, 'hours')
    let settingArrNo = 0
    const deviceValveSettings = []
    const deviceValveSettingsById = {}
    let settingNew = true

    /*
        The following create array of current settings on devices
          in order to convert this to work on double valves...
          we probably need to create an object based around device ID's
          which then is reassembled later. this object would need to
          track the valve number the device id is trying to track
    */
    for (let i = 0; i < devices.length; i += 1) {
      const device = devices[i]
      const {
        interface_versioned: {
          data: {
            other: {
              valveNumber = 1,
            } = {},
          } = {},
        } = {},
      } = device
      let valveTime = [
        toValveTime(
          VALVE_OPEN,
          valveNumber,
          1483228800
        ),
        toValveTime(
          VALVE_CLOSE,
          valveNumber,
          1483228801 // time in the past
        ),
      ]
      if (
        device.application_settings_new &&
        device.application_settings_new.status === 'new' &&
        device.application_settings_new.settings &&
        device.application_settings_new.settings.valveTime
      ) {
        valveTime = device.application_settings_new.settings.valveTime
      } else if (
        device.application_settings &&
        device.application_settings.settings &&
        device.application_settings.settings.valveTime
      ) {
        valveTime = device.application_settings.settings.valveTime
      }
      deviceValveSettings.push({
        address: device.address,
        deviceId: device.id,
        status: 'new',
        settings: {
          valveTime,
        },
      })

      deviceValveSettingsById[device.id] = {
        valveNumber,
        setting: {
          address: device.address,
          status: 'new',
          settings: {
            valveTime,
          },
        },
      }
    }

    /*

      This determines if we are trying to create a new setting or edit
      a current setting. If editing, we load up the state values for
      start, stop, etc.

        to convert this to double valves or more, it doesn't look
        like we need to do anything, as long as we keep only try to
        control one valve per device id

    */
    let settingNoP = Number.parseInt(params?.settingNo, 10)
    if (!settingNoP || settingNoP === 'new') {
      settingNew = true
    } else {
      const valveTime = deviceValveSettings[0].settings.valveTime
      settingNew = false
      if (!settingNoP) {
        if (valveTime && valveTime.length > 0) {
          settingNoP = (valveTime.length / 2) + 1
        } else {
          settingNoP = 1
        }
      }
      settingArrNo = (settingNoP * 2) - 1 - 1
      if (settingArrNo < 0) {
        settingArrNo = 0
      }
      if (settingNoP) {
        if (valveTime.length >= settingArrNo + 1) {
          startTime = moment(valveTimeToEpochMillis(valveTime[settingArrNo]))
          stopTime = moment(valveTimeToEpochMillis(valveTime[settingArrNo + 1]))
          selectedDay = startTime.clone()
          selectedTime = startTime.clone()
          selectedRunTimeHours = stopTime.diff(startTime, 'hours')
          selectedRunTimeMinutes = stopTime.diff(startTime, 'minutes') % 60
        }
      }
    }

    setSelectedDay(selectedDay)
    setSelectedTime(selectedTime)
    setSelectedRunTimeHours(selectedRunTimeHours)
    setSelectedRunTimeMinutes(selectedRunTimeMinutes)
    setStartTime(startTime)
    setStopTime(stopTime)
    setDeviceValveSettings(deviceValveSettings)
    setDeviceValveSettingsById(deviceValveSettingsById)
    setSettingArrNo(settingArrNo)
    setSettingNew(settingNew)
  }, [devices, params])

  const handleDateChange = useCallback((event) => {
    const value = event.target.value
    if (value) {
      setSelectedDay(moment(value, 'YYYY-MM-DD'))
    }
  }, [])

  const handleTimeChange = useCallback((event) => {
    const value = event.target.value
    setSelectedTime(moment(value, 'HH:mm'))
  }, [])

  const handleHourChange = useCallback((event) => {
    const value = event.target.value
    setSelectedRunTimeHours(Number(value))
  }, [])

  const handleMinuteChange = useCallback((event) => {
    const value = event.target.value
    setSelectedRunTimeMinutes(Number(value))
  }, [])

  const appDispatch = useCallback(() => {
    if (!deviceValveSettings || deviceValveSettings.length === 0) {
      return
    }

    const deviceValveSettingsClone = JSON.parse(JSON.stringify(deviceValveSettings))

    // With double valves we create two entries for the same device address in the setting payload
    // we need to combine the two sets of settings for the same address
    // AND we don't want the same exact setting twice
    const dVObj = deviceValveSettingsClone.reduce((acc, obj) => {
      const { address } = obj

      // if the device doesn't exist yet, add
      if (!acc[address]) {
        acc[address] = obj
      }

      // turn both the first and second device setting arrays to 2D arrays
      const firstVT = []
      for (let index = 0; index < obj.settings.valveTime.length; index += 2) {
        firstVT.push([obj.settings.valveTime[index], obj.settings.valveTime[index + 1]])
      }
      const secondVT = []
      for (let index = 0; index < acc[address].settings.valveTime.length; index += 2) {
        secondVT.push([acc[address].settings.valveTime[index], acc[address].settings.valveTime[index + 1]])
      }

      // combine and only take unique values
      const combinedVT = _uniqWith([...firstVT, ...secondVT], _isEqual)

      // sort the array
      combinedVT.sort((a, b) => {
        return a[0] - b[0]
      })

      // convert back to 1D array
      const combinedVT1D = []
      for (let index = 0; index < combinedVT.length; index += 1) {
        combinedVT1D.push(combinedVT[index][0], combinedVT[index][1])
      }

      acc[address].settings.valveTime = combinedVT1D
      return acc
    }, {})
    const deviceValveSettingsMerged = Object.keys(dVObj).map(key => (dVObj[key]))

    AppDispatcher.dispatch({
      action: 'change-setting',
      setting: deviceValveSettingsMerged,
    })
  }, [deviceValveSettings])

  useEffect(() => {
    appDispatch()
  }, [appDispatch])

  // Update start/stop when dependencies change
  useEffect(() => {
    if (!selectedDay || !selectedTime) {
      return
    }
    if (Object.keys(deviceValveSettingsById).length === 0) {
      return
    }

    const pastStartTime = startTime.clone()
    const pastStopTime = stopTime.clone()

    // need to switch this to UTC time and back to solve a bug related to creating this time
    const newStartTime = moment(
      `${selectedDay.format('YYYY-MM-DD')}T${selectedTime.format('HH:mm')}:00${selectedTime.format('Z')}`
    )
    const newStopTime = newStartTime.clone()
    newStopTime.add(selectedRunTimeHours, 'hours')
    newStopTime.add(selectedRunTimeMinutes, 'minutes')

    const hasTimeChanged = !pastStartTime.isSame(newStartTime) || !pastStopTime.isSame(newStopTime)

    if (hasTimeChanged) {
      setStartTime(newStartTime)
      setStopTime(newStopTime)
    }

    setDeviceValveSettings((prevSettings) => {
      if (!prevSettings || prevSettings.length === 0) {
        return prevSettings
      }

      const updatedSettings = prevSettings.map((deviceSetting) => {
        const {
          settings: {
            valveTime,
          },
          deviceId,
        } = deviceSetting
        const { valveNumber } = deviceValveSettingsById[deviceId] || {}

        if (valveNumber === undefined) {
          return deviceSetting
        }

        // first convert the array to a 2D array we can modify
        const vTClone = []
        for (let i = 0; i < valveTime.length; i += 2) {
          vTClone.push([valveTime[i], valveTime[i + 1]])
        }

        // then copy only current and future settings
        const nowEpoch = moment().unix()
        const vTCloneFuture = vTClone.filter(s => valveTimeToEpoch(s[1]) > nowEpoch)

        // now we need to either replace the setting already in the array
        // or we need to add it as new to the end of the array
        const indexOfPast = vTCloneFuture.findIndex((e) => {
          return (
            e[0] === toValveTime(
              VALVE_OPEN,
              valveNumber, // valve number
              pastStartTime.unix() // time in unix seconds
            ) &&
            e[1] === toValveTime(
              VALVE_CLOSE,
              valveNumber, // valve number
              pastStopTime.unix() // time in unix seconds
            )
          )
        })

        if (indexOfPast === -1) {
          // since we don't have it, push it in
          vTCloneFuture.push([
            toValveTime(
              VALVE_OPEN,
              valveNumber, // valve number
              newStartTime.unix() // time in unix seconds
            ),
            toValveTime(
              VALVE_CLOSE,
              valveNumber, // valve number
              newStopTime.unix() // time in unix seconds
            ),
          ])
        } else {
          // already in, so replace whats there
          vTCloneFuture.splice(
            indexOfPast,
            1,
            [
              toValveTime(
                VALVE_OPEN,
                valveNumber, // valve number
                newStartTime.unix() // time in unix seconds
              ),
              toValveTime(
                VALVE_CLOSE,
                valveNumber, // valve number
                newStopTime.unix() // time in unix seconds
              ),
            ]
          )
        }

        // sort
        vTCloneFuture.sort((a, b) => {
          return a[0] - b[0]
        })

        // convert back to 1D array
        const valveTimeClone = []
        for (let i = 0; i < vTCloneFuture.length; i += 1) {
          valveTimeClone.push(vTCloneFuture[i][0], vTCloneFuture[i][1])
        }

        // update the setting
        return {
          address: deviceSetting.address,
          deviceId: deviceSetting.deviceId,
          status: deviceSetting.status,
          settings: {
            valveTime: valveTimeClone,
          },
        }
      })

      if (_isEqual(prevSettings, updatedSettings)) {
        return prevSettings
      }

      return updatedSettings
    })
  }, [selectedDay, selectedTime, selectedRunTimeHours, selectedRunTimeMinutes, deviceValveSettingsById, startTime, stopTime])

  return (
    <div className={`${styles.inputArea} ${styles.paddedInputArea}`}>
      <section>
        <h5>
          Start Date
        </h5>
        <div
          className={styles.dayPicker}
          style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '20px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            display: 'inline-block',
          }}
        >
          <input
            type='date'
            value={selectedDay.format('YYYY-MM-DD')}
            onChange={handleDateChange}
          />
        </div>
      </section>
      <section className={styles.sectionWidthCenter}>
        <h5>
          Start Time
        </h5>
        <div className={styles.startTime}>
          <TimeInput
            value={selectedTime.format('HH:mm')}
            field='startTime'
            childChange={handleTimeChange}
            style={styles.startTimeInput}
          />
        </div>
      </section>
      <section className={styles.sectionWidthCenter}>
        <h5>
          Run Time
        </h5>
        <div>
          <div className={styles.runTimeInput}>
            <SelectInput
              value={selectedRunTimeHours}
              field='runTimeHours'
              childChange={handleHourChange}
              options={options.hours}
              style={styles.runTimeSelect}
            />
          </div>
          <div className={styles.runTimeInput}>
            <SelectInput
              value={selectedRunTimeMinutes}
              field='runTimeMinutes'
              childChange={handleMinuteChange}
              options={options.minutes}
              style={styles.runTimeSelect}
            />
          </div>
        </div>
      </section>
    </div>
  )
}

TimeSet.propTypes = {
  devices: PropTypes.array.isRequired,
  params: PropTypes.object,
}

export default withAppStore(TimeSet)
